const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/persons/$id.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindPersonDetailsQueryOptions } from '@api';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { t } from 'i18next';
export const Route = createFileRoute('/_rootLayout/persons/$id')({
  beforeLoad: ({
    params,
    matches
  }) => {
    const lastMatch = matches[matches.length - 1];
    if (!lastMatch.id.endsWith(`/persons/${params.id}`)) return;
    redirect({
      to: '/persons/$id/general',
      params: {
        id: params.id
      },
      throw: true,
      replace: true
    });
  },
  loader: async ({
    context: {
      queryClient
    },
    params
  }) => {
    queryClient.ensureQueryData(getFindPersonDetailsQueryOptions(params.id));
    return {
      crumb: t('NAVIGATION.PERSONS'),
      to: '/persons'
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});